<script lang="ts">
  import { TG_CHAT_LINK } from '../lib/bot-links';
  import { openBotLink } from '../lib/telegram';
  import Icon from './Icon.svelte';

  type Tab = 'home' | 'catalog' | 'schedule' | 'profile';
  interface Props {
    active: Tab;
  }
  let { active }: Props = $props();

  // Index of the active tab in the visible nav order (5 columns).
  // Index 2 is the external chat link — never "active", but kept for layout.
  const indexMap: Record<Tab, number> = { home: 0, catalog: 1, schedule: 3, profile: 4 };
  const activeIndex = $derived(indexMap[active]);
</script>

<div class="bottom-nav">
  <div class="nav-indicator" style="--idx: {activeIndex}"></div>
  <a class="nav-item" class:active={active === 'home'} href="#/home">
    <div class="nav-icon"><Icon name="house" size="nav" /></div>
    <div class="nav-label">Головна</div>
  </a>
  <a class="nav-item" class:active={active === 'catalog'} href="#/catalog">
    <div class="nav-icon"><Icon name="library-big" size="nav" /></div>
    <div class="nav-label">База знань</div>
  </a>
  <a
    class="nav-item"
    href={TG_CHAT_LINK}
    target="_blank"
    rel="noopener"
    onclick={(e) => openBotLink(e, TG_CHAT_LINK)}
  >
    <div class="nav-icon"><Icon name="message-circle" size="nav" /></div>
    <div class="nav-label">Чат простору</div>
  </a>
  <a class="nav-item" class:active={active === 'schedule'} href="#/schedule">
    <div class="nav-icon"><Icon name="calendar-days" size="nav" /></div>
    <div class="nav-label">Розклад</div>
  </a>
  <a class="nav-item" class:active={active === 'profile'} href="#/profile">
    <div class="nav-icon"><Icon name="user-round" size="nav" /></div>
    <div class="nav-label">Профіль</div>
  </a>
</div>

<style>
  .bottom-nav {
    border-top: 0.5px solid var(--border);
    display: flex;
    padding: 8px 0 calc(12px + env(safe-area-inset-bottom));
    flex-shrink: 0;
    background: var(--bg);
    position: relative;
  }
  /* Sliding indicator that tracks the active tab */
  .nav-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 20%;
    height: 2px;
    transform: translateX(calc(var(--idx) * 100%));
    transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
    pointer-events: none;
    display: flex;
    justify-content: center;
  }
  .nav-indicator::after {
    content: '';
    width: 40px;
    height: 2px;
    background: var(--pu);
    border-radius: 0 0 2px 2px;
  }
  .nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    cursor: pointer;
    padding: 3px;
    color: inherit;
    text-decoration: none;
  }
  .nav-icon {
    font-size: 17px;
    transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  }
  .nav-item.active .nav-icon {
    transform: scale(1.15) translateY(-1px);
  }
  .nav-label {
    font-size: 9px;
    color: var(--text-muted);
    transition: color 0.2s var(--ease);
  }
  .nav-item.active .nav-label {
    color: var(--accent-text);
    font-weight: 600;
  }
</style>
